module.exports = __webpack_public_path__ + "img/xieroudanhuang.d2590f9a.jpg";